// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2jOCA","description":"PatientConsentPreview_description__2WesZ"};